import _Abstract from "system/abstract"
import UtilsMath from "lib/utils-math";

export default class Component_RotateOnScroll extends _Abstract {

  constructor(el, options) {

      var defaultOptions = {
                                //Note the radius is based on the screen width
                                //so 1920 = 1 scale
                                //so if a radius of 400 is passed in, then at 1920 browser width it'll be 400 radius
                                //If at browser width of 960 then it'll be 200 radius
                                "radius":null,
                                "rotation_times_per_screen_height":1,       //rotation_times_per_screen_height means that it'll rotate the element once fully based on a scroll of a whole page if set to 1
                                "begin_rotation_around_point_degrees":0,    
                                "initial_image_rotation_degrees":0,
                                "radius_percentage_of_parent_width":false   //set a percentage value to determine the radius based on the parent (width /2)
                              }

    super(el, $.extend(true, defaultOptions, options), 'component')
    
  
    if(this.options.radius === null && !this.options.radius_percentage_of_parent_width)
    {
        console.log("A radius must be passed in as an option for RotateOnScroll, or radius_percentage_of_parent_width set");
        return;
    }

    this.$parent = this.$el.parent();
    this.$window = $(window);

    this.initialise();
  }

  initialise()
  {
      this.setPositionBasedOnScroll();
  }


  setPositionBasedOnScroll()
  {

        if(this.options.radius_percentage_of_parent_width)
        {
            var radius = (this.$parent.width() * 0.5) * (this.options.radius_percentage_of_parent_width * 0.01);
        }
        else
        {
            var vw = $(window).width()/1920;
            var radius = this.options.radius * vw;
        }

        var numberOfWindowHeightScrolled = this.getNumberOfWindowHeightScrolled();
        var rotation = (360 * numberOfWindowHeightScrolled * this.options.rotation_times_per_screen_height) + this.options.begin_rotation_around_point_degrees;
        var numberOf360s = Math.floor(rotation / 360);
        rotation -= (360 * numberOf360s);
        var x = UtilsMath.polarToCartesianX(radius, rotation, true);
        var y = UtilsMath.polarToCartesianY(radius, rotation, true)
        this.$el.css("transform","translate3d("+x+"px,"+y+"px,0) rotate("+(rotation + this.options.initial_image_rotation_degrees)+"deg)");

        window.requestAnimationFrame(() => this.setPositionBasedOnScroll());
  }

  getNumberOfWindowHeightScrolled()
  { 
      var windowHeight = this.$window.height();
      var scrollTopPosition = this.$window.scrollTop();
      return scrollTopPosition / windowHeight;
  }
}


/** WEBPACK FOOTER **
 ** ./components/rotate-on-scroll.js
 **/